(function ($) {
    $('a.pos__header_back').on('click', function(e){
        if (window.history.length > 1) {
            window.history.back(); // go back in history
            e.preventDefault();
        }
    })
})(jQuery);
